import { ModusWcTypography } from '@trimble-oss/moduswebcomponents-react';
import { useTranslation } from 'react-i18next';

export const ErrorComponent = () => {
  const { t } = useTranslation();
  return (
    <div className='h-[100dvh] w-[100dvw] flex flex-col gap-8 items-center justify-center'>
      <ModusWcTypography hierarchy='h1'>
        {t('errorComponent.title')}
      </ModusWcTypography>
    </div>
  );
};
